<section class="vh-100 main-bg" >
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div
          class="shadow-2-strong"
          style="border-radius: 1rem; border: none"
        >
          <div class="card-body p-5 text-center otp-box">
            <h1 class="mb-5" style="color: #fff; align-self: auto;font-size: 32px;font-weight: 300;">
              Enter your OTP
            </h1>
            <div>
              <div class="otp-container">
                <input
                  type="text"
                  class="otp-input"
                  maxlength="1"
                  id="otp1"
                  [(ngModel)]="otpValues[0]"
                  (keydown)="onKeyDown($event, 0)"
                  #otpInput
                />
                <input
                  type="text"
                  class="otp-input"
                  maxlength="1"
                  id="otp2"
                  [(ngModel)]="otpValues[1]"
                  (keydown)="onKeyDown($event, 1)"
                  #otpInput
                />
                <input
                  type="text"
                  class="otp-input"
                  maxlength="1"
                  id="otp3"
                  [(ngModel)]="otpValues[2]"
                  (keydown)="onKeyDown($event, 2)"
                  #otpInput
                />
                <input
                  type="text"
                  class="otp-input"
                  maxlength="1"
                  id="otp4"
                  [(ngModel)]="otpValues[3]"
                  (keydown)="onKeyDown($event, 3)"
                  #otpInput
                />
                <input
                  type="text"
                  class="otp-input"
                  maxlength="1"
                  id="otp5"
                  [(ngModel)]="otpValues[4]"
                  (keydown)="onKeyDown($event, 4)"
                  #otpInput
                />
                <input
                  type="text"
                  class="otp-input"
                  maxlength="1"
                  id="otp6"
                  [(ngModel)]="otpValues[5]"
                  (keydown)="onKeyDown($event, 5)"
                  #otpInput
                />
              </div>
            </div>
            <span *ngIf="submited && message" class="alert-message">OTP CANNOT BE EMPTY</span>
            <span *ngIf="delete_account_message" class="alert-message">
              INVALID OTP
            </span>
            <span *ngIf="char_message" class="alert-message">
              ONLY NUMERIC VALUES ARE ALLOWED
            </span>
            <span *ngIf="unauthorised" class="alert-message">
              UNAUTHORISED ACCESS
            </span>
            <span *ngIf="somethingWentWrong" class="alert-message">
              SOMETHING WENT WRONG
            </span>
            <div>
              <button type="submit" (click)="onSubmit()" style="width: 100%">
                <span *ngIf="!submited">SUBMIT</span>
                <span *ngIf="submited && message">SUBMIT</span>
                <span *ngIf="submited && !message" class="spinner-border sr-only" role="status"></span>
              </button>
              <div
                class="resend-otp-text"
                type="button"
                (click)="redirect_request_page()"
            
              >
                Resend OTP
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
